const API_BASE_URL = "https://pure-basin-09964.herokuapp.com/";

// const API_BASE_URL = "http://localhost:8001/";

export default API_BASE_URL;
